import FloatField from './floatField';

/**
 * @class LengthUnitField
 */
export default class LengthUnitField extends FloatField {
    type = 'lengthUnit';
    supports = null;

    /**
     * `<div/>` container of field
     *
     * @property {jQuery} control
     */

    /**
     * `<input/>` element of field
     *
     * @property {jQuery} input
     */

    /**
     * Measurements Converter e.g. to convert between mm and inch.
     *
     * @property {MeasurementsConverter} converter
     */

    /**
     * Length unit object.
     *
     * @property {LengthUnit} lengthUnit
     */

    /**
     * Command executor.
     *
     * @property {CommandExecutor} commandExecutor
     */

    /**
     * Initializes the field
     *
     * @param {jQuery} control `<div/>` container of field
     * @param {Object} translations
     * @param {MeasurementsConverter} converter
     * @param {LengthUnit} lengthUnit
     * @param {CommandExecutor} commandExecutor - Global command executor
     */
    constructor(control, translations, converter, lengthUnit, commandExecutor) {
        super(control, translations);

        this.converter = converter;
        this.lengthUnit = lengthUnit;
        this.commandExecutor = commandExecutor;
    }

    /**
     * Set input field value.
     *
     * @param {number} value
     */
    setValue(value) {
        const convertedValue = this.converter.convertTo(value, this.lengthUnit, 2);
        this.input.val(convertedValue);
    }

    /**
     * Get input field value.
     *
     * @return {number}
     */
    getValue() {
        const value = parseFloat(this.input.val().replace(',', '.'));

        return this.converter.convertFrom(value, this.lengthUnit, 2);
    }
}
